import { Nav } from '@dagens/carrot';
import { useNavLinksConsumer } from '../../hooks/use-nav-links-consumer';

export const BottomNavConsumer = () => {
  const links = useNavLinksConsumer();
  return <Nav.Tabs links={links} />;
};
